<template>
    <van-nav-bar
        title="提报回复"
        style="margin-bottom: 10px"
    />
    <van-cell title="提报单号" style="border-radius: 15px 15px 0px 0px;" >
        <span>{{ reply_List.id }}</span>
    </van-cell>
    <van-cell title="提报标题" >
        <span>{{ reply_List.title }}</span>
    </van-cell>
    <van-cell title="提报类型" v-if="reply_List.type == 1">
        <span style="color: red">匿名提报</span>
    </van-cell>
    <van-cell title="提报类型" v-else>
        <span style="color: blue">署名提报</span>
    </van-cell>
    <van-cell title="提报人" v-if="reply_List.type == 2">
        <span>{{ reply_List.name }}</span>
    </van-cell>
    <van-cell title="提报电话" v-if="reply_List.type == 2">
        <span>{{ reply_List.phone }}</span>
    </van-cell>
    <van-cell title="发生日期" >
        <span>{{ reply_List.happen_Date }}</span>
    </van-cell>
    <van-field
        :placeholder="reply_List.description"
        label="提报内容"
        autosize
        type="textarea"
        readonly
        label-align="top"
    />
    <van-floating-bubble
        axis="xy"
        icon="chat"
        magnetic="x"
        style="--van-floating-bubble-background: #16b777"
        @click="bubbleBottom"
    />
    <van-popup
        v-model:show="popupShow"
        round
        position="bottom"
        :style="{ height: '70%' }"
    >
        <van-nav-bar title="未处理提报" style="position:fixed;width: 100%;" />
        <van-cell-group inset style="margin-top: 40px">
            <van-collapse v-model="activeNames" accordion v-if="Object.keys(view_component).length!=0">
                <div v-for="component in view_component" :key="component.id">
                    <van-collapse-item v-if="component.type == 1" title="投诉单号" icon="notes-o" :name=component.id :value=component.id label="匿名提报" style="--van-cell-label-color: red">
                        <p><span style="color: DeepSkyBlue">提报日期：</span>{{ component.happen_Date }}</p>
                        <p><span style="color: DeepSkyBlue">提报标题：</span>{{ component.title }}</p>
                        <p></p>
                        <van-button
                            icon="chat-o"
                            size="small"
                            style="float: right;margin-bottom: 10px"
                            type="success"
                            @click="reply_onSubmit(component)"
                        >
                            回复
                        </van-button>
                    </van-collapse-item>
                    <van-collapse-item v-else title="投诉单号" icon="notes-o" :name=component.id :value=component.id label="署名提报" style="--van-cell-label-color: blue">
                        <p><span style="color: DeepSkyBlue">提报人：</span>{{ component.name }}</p>
                        <p><span style="color: DeepSkyBlue">手机号：</span>{{ component.phone }}</p>
                        <p><span style="color: DeepSkyBlue">提报日期：</span>{{ component.happen_Date }}</p>
                        <p><span style="color: DeepSkyBlue">提报标题：</span>{{ component.title }}</p>
                        <p></p>
                        <van-button
                            icon="chat-o"
                            type="success"
                            size="small"
                            style="float: right;margin-bottom: 10px"
                            @click="reply_onSubmit(component)"
                        >
                            回复
                        </van-button>
                    </van-collapse-item>
                </div>
            </van-collapse>
            <van-notice-bar color="#1989fa" background="#ecf9ff" v-else left-icon="info-o" style="margin-top: 50px">
                没有未处理的提报。
            </van-notice-bar>
        </van-cell-group>
    </van-popup>
    <van-form @submit="onSubmit" v-if="suc">
            <van-field
                v-model="feedback"
                name="feedback"
                rows="2"
                autosize
                label="回复内容"
                type="textarea"
                maxlength="300"
                placeholder="请输入回复内容"
                :rules="[{ required: true, message: '请填写回复内容' }]"
                show-word-limit
            />
            <div style="margin: 16px;">
                <van-button round block type="primary" native-type="submit">
                    回复提报
                </van-button>
            </div>
    </van-form>
    <van-field v-else
        v-model="reply_List.feedback"
        label="回复内容"
        autosize
        type="textarea"
        readonly
        label-align="top"
        error
        style="border-radius: 0px 0px 15px 15px;"
    />
</template>
<script setup>
    import {onMounted, ref} from "vue";
    import axios from "axios";
    import {closeToast, showFailToast, showLoadingToast, showSuccessToast} from "vant";
    const popupShow = ref(false)
    const feedback = ref("");
    const reply_List = ref([]);
    const activeNames = ref("");
    const suc = ref(true);
    const view_component = ref([]);

    /*
    * 基础查询方法
    * */
    onMounted(() =>{
        window.document.title = '宁波万汇投诉建议回复平台'
        showLoadingToast({
            overlay:true,
            forbidClick:true,
            message: '加载中...',
            duration:0
        });
        axios.post("https://afa.activa-leisure.com/lj/back/view_complaint",
            {
                TS_ID:location.href.split('reply_id=')[1].split(',')[0],
                state:2,
            },
            {
                headers:{
                    "content-type": "application/x-www-form-urlencoded"
                }
            }
        ).then( result => {
            closeToast();
            reply_List.value = result.data.data[0]
            if(reply_List.value.state == "Y"){
                suc.value = false
            }
            console.log(reply_List.value);
        })
    })
    /*
    * 回复提报方法
    * */
    const onSubmit = (values) => {
        Object.assign(values,{id:reply_List.value.id,p_open_id:location.href.split('reply_id=')[1].split(',')[1]})
        console.log(values)
        showLoadingToast({
            overlay:true,
            forbidClick:true,
            message: '提交中...',
            duration:0
        });
        // console.log('submit', values);
        axios.post("https://afa.activa-leisure.com/lj/back/reply_complaint",
            values,
            {
                headers:{
                    "content-type": "application/x-www-form-urlencoded"
                }
            }).then( result =>{
                closeToast();
                if (result.data.success){
                   // view_component.value = result.data.data
                    reply_List.value.feedback = values.feedback
                    feedback.value = "";
                    suc.value = false
                    showSuccessToast('提交成功');
                }else {
                    showFailToast('提交失败');
                }
        })
    };
    /*
    * 查看未提报内容方法
    * */
    const bubbleBottom = () => {
        showLoadingToast({
            overlay:true,
            forbidClick:true,
            message: '加载中...',
            duration:0
            // forbidClick: true,
        });
        axios.post("https://afa.activa-leisure.com/lj/back/view_complaint",{
                state:3,
            },
            {
                headers:{
                    "content-type": "application/x-www-form-urlencoded"
                }
            }).then( result =>{
            closeToast();
            view_component.value = result.data.data
        })
        popupShow.value = true
    }
    /*
    * 回复按钮方法
    * */
    const reply_onSubmit = (reply_on) => {
        reply_List.value = reply_on;
        suc.value = true;
        popupShow.value = false;
    }
</script>
<style scoped>
</style>